import { defineComponent, ref, onMounted, createElementBlock, openBlock, createCommentVNode, createVNode, createElementVNode, toDisplayString, unref } from 'vue';
import script from './basler-components.es614.js';

const _hoisted_1 = { class: "media-chart" };
const _hoisted_2 = {
  key: 0,
  class: "text rte-text chart-title mb-2"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaChart",
  props: {
    media: {}
  },
  setup(__props) {
    const props = __props;
    const chartData = ref();
    const chartOptions = ref();
    const chartType = ref();
    const chartDescription = ref();
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--chart-text-color");
    const textColorSecondary = documentStyle.getPropertyValue("--chart-text-color");
    const surfaceBorder = documentStyle.getPropertyValue("--chart-border-color");
    const primaryColor = documentStyle.getPropertyValue("--chart-primary-color");
    const backgroundColor = documentStyle.getPropertyValue("--white");
    onMounted(() => {
      chartData.value = setChartData();
      chartOptions.value = setChartOptions();
      chartType.value = props.media.chartType ?? "line";
      chartDescription.value = props.media.chartDescription;
    });
    const setChartData = () => {
      const transformedData = props.media.chartData;
      return {
        datasets: [
          {
            label: null,
            data: transformedData,
            borderColor: primaryColor,
            backgroundColor,
            borderWidth: 2,
            fill: false,
            tension: 0.1,
            pointBackgroundColor: primaryColor,
            pointBorderColor: primaryColor,
            pointRadius: 2,
            spanGaps: false
            // Verbindet keine Punkte über null-Werte hinweg
          }
        ]
      };
    };
    const setChartOptions = () => {
      return {
        responsive: true,
        maintainAspectRatio: true,
        animation: true,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            type: "linear",
            position: "bottom",
            title: {
              display: true,
              text: props.media.xTitleText ?? "",
              color: textColor
            },
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          },
          y: {
            type: "linear",
            suggestedMax: "1.1",
            title: {
              display: true,
              text: props.media.yTitleText ?? "",
              color: textColor
            },
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          }
        },
        elements: {
          point: {
            radius: 3,
            hoverRadius: 4
          },
          line: {
            tension: 0.1
          }
        }
      };
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        chartDescription.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createElementVNode("h2", null, toDisplayString(chartDescription.value), 1)
        ])) : createCommentVNode("", true),
        createVNode(unref(script), {
          type: chartType.value,
          data: chartData.value,
          options: chartOptions.value
        }, null, 8, ["type", "data", "options"])
      ]);
    };
  }
});

export { _sfc_main as default };
